// ./frontend/src/actions/uiAction.js
import { 
  SHOW_LOADER, 
  HIDE_LOADER, 
  SHOW_NOTIFICATION,
  MODAL,
  THANK_YOU_MODAL,
  USER_PASSWORD,
	NOTIFICATION_MODAL
} from "../config";
import { actions } from "react-redux-form";

export const showLoader=()=>(dispatch)=>dispatch({type: SHOW_LOADER})

export const hideLoader=()=> (dispatch)=>dispatch({type: HIDE_LOADER})

export function showHideModal(value) {
	return {
    type: MODAL,
		payload : value
  }
}
/* NAme : Neha, Desc: Function is used to display notification modal if user receives unique code via email */
export function showHideNotificationModal(value) {
	return {
    type: NOTIFICATION_MODAL,
		payload : value
  }
}
export function showHideThankYouModal(value) {
	return {
    type: THANK_YOU_MODAL,
	payload : value
  }
}
export const notification=(message)=> (dispatch)=>{
  dispatch({type: SHOW_NOTIFICATION,message:""})
  setTimeout(()=>dispatch({type: SHOW_NOTIFICATION, message}),0)    
}
/* Name : Neha Desc : Function is used to reset the modal values. */
export function resetModalValues(model) {
  return function(dispatch) {
    dispatch(actions.reset(model))
  }
}

export function hideShowPassword(flag){
	return{
		type : USER_PASSWORD,
		payload : flag
	}
}

export function setNativeValue(element, value) {
if (element) {
let lastValue = element.value;
element.value = value;
let event = new Event("input", { target: element, bubbles: true });
let tracker = element._valueTracker;
if (tracker) {
tracker.setValue(lastValue);
}
return () => { element.dispatchEvent(event) };
}
}

export function refreshNativeDataTable(element) {
  if (element) {
    // Create and dispatch a click event on the element
    let event = new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window
    });
    return () => { element.dispatchEvent(event) };
  } else {
    console.error('Fallback element not found',6300);
    //window.location.reload();
  }
}